var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.833333 .833333)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#8EDAEA",
    cx: 16.8,
    cy: 16.8,
    r: 16.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1701858 14.032582c-.0790409-.3221784-.4046863-.5653925-.6449688-.5653925l-6.2346982-.8907293-2.7506026-5.66024005c-.322484-.56539248-1.2140589-.56539248-1.5365429 0l-2.753764 5.66024005-6.31373831.8907293c-.3224848 0-.5659287.2432141-.64496879.5653925-.08220231.3221792 0 .6475161.24028249.8907301l4.53375081 4.3652071-1.0528165 6.2256325c-.07904013.3253376.0822015.6475161.3256462.8086057.2402825.1610896.6449688.2432132.8884127.0821236l5.586568-2.9122436 5.5834059 2.9122436c.1612424.078966.2434439.078966.4046863.078966s.3224848-.078966.4868886-.1610896c.2402825-.1610896.4046863-.4832681.322484-.8086057l-1.0528165-6.2256325 4.5337507-4.3652071c.1612424-.243214.2434447-.6475169.0790409-.8907301z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.4622f98693c2deb2186e360b5c5babc0.svg";
export { ForwardRef as ReactComponent };